// File: frontend/src/pages/ThankYouPage.jsx

/*
  ThankYouPage displays a confirmation message after form submission.
  Shows submitted date and field values.
  Provides navigation buttons to return home or submit another entry.
*/
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { fieldLabels } from '../fieldConfig';

// Access location state to retrieve submitted date and field data
const ThankYouPage = () => {
  const location = useLocation();
  const { date, fields } = location.state || {};

  // Fallback when accessed directly (no state from form submission)
  if (!date && !fields) {
    return (
      <div className="entry-page">
        <PageHeader title="Thank You" section="gatherings" />
        <div className="entry-success-card">
          <h2>Thank You</h2>
          <p style={{ color: 'var(--cr-text-muted)', marginBottom: '1.5rem' }}>No submission data to display. You may have arrived here directly.</p>
          <div className="success-buttons">
            <Link to="/dynamic-entry" className="btn-primary">Add Group Data</Link>
            <Link to="/gatherings" className="btn-outline">Back to Gatherings</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="entry-page">
      <PageHeader title="Thank You" section="gatherings" />
      <div className="entry-success-card">
        <div className="success-icon">✓</div>
        <h2>Thank You for Submitting!</h2>
        <p style={{ color: 'var(--cr-text-muted)', margin: '0 0 0.5rem 0' }}>You've successfully submitted the following report for:</p>
        <p style={{ fontWeight: 600, color: 'var(--cr-text)', margin: '0 0 1rem 0' }}>Date: {date}</p>
        <div className="success-summary">
          {fields && Object.entries(fields).map(([field, value]) => (
            <div key={field} style={{ marginBottom: '0.35rem', fontSize: '0.95rem', color: 'var(--cr-text)' }}>
              <strong>{fieldLabels[field] ?? field}</strong>: {value}
            </div>
          ))}
        </div>
        <div className="success-buttons" style={{ marginTop: '1.5rem' }}>
          <Link to="/dynamic-entry" className="btn-primary">Submit Another Entry</Link>
          <Link to="/gatherings" className="btn-outline">Back to Gatherings</Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;